import React, { useState } from "react";
import ButtonStyle from "./buttonstyle";
import Form from "./form";
import P from "./p";
import Page from "./page";
import PageHeader from "./pageheader";
import Radio from "./radio";
import Title from "./title";
import { Link } from "react-router-dom";
import { SmallDivider } from "../shared";
import { useQuery } from "@tanstack/react-query";

function CIR({ nextUrl }) {
  return (
    <>
      <PageHeader
        title="Membership Application"
        tagline="Welcome to The Battery Creative in Residence Program"
      >
        <P style={{ marginBottom: "1rem" }}>
          We are delighted to offer you a complimentary Creative in Residence Membership at The
          Battery! With this, you'll have full access to the Club's events, restaurants, and bars.
          The most important element of The Battery is the Members themselves.
        </P>
        <P style={{ marginBottom: "1rem" }}>
          <em>Your perspective and passion will help us define The Club and its ethos.</em>
        </P>
        <P style={{ marginBottom: "1rem" }}>
          To get your CIR Membership up and running, we just need to collect a few bits of
          information from you.
        </P>
      </PageHeader>
      <Link style={ButtonStyle({ enabled: true })} to={nextUrl}>
        Continue
      </Link>
    </>
  );
}
function Standard({ form, nextUrl, submitUrl, setForm, prices, initiation_fee_amt, name }) {
  const InitiationFee = () => {
    return Boolean(parseInt(initiation_fee_amt)) ? (
      <span>Initiation fee will be ${parseInt(initiation_fee_amt)}.</span>
    ) : (
      ""
    );
  };
  return (
    <>
      <PageHeader title="Membership Application" tagline="We’re glad you’re here.">
        <P>
          We’re looking forward to learning more about you. As you go through the application form,
          your answers will be saved so you can reference them later. Edits can be made, perfection
          can be achieved. Select the membership type that best fits you below:
        </P>
      </PageHeader>
      <Title>membership types</Title>
      <Form form={form} setForm={setForm} nextUrl={nextUrl} showBack={false} submitUrl={submitUrl}>
        <Radio
          name={name}
          form={form}
          setForm={setForm}
          choices={prices.map((n) => ({
            id: n.membership_price_id,
            name: n.membership_type_cd,
            description: n.description_tx,
            detail: `$${parseInt(n.annual_fee_amt)} / year`
          }))}
        />
        <P>Membership type subject to verification</P>
        <div style={{ marginBottom: "1rem" }}>
          <SmallDivider />
        </div>
        <div style={{ marginBottom: 36 }}>
          <Title>payment details</Title>
        </div>
        <div style={{ marginBottom: "2rem" }}>
          <P>
            $100 of your membership dues supports the Battery Powered philanthropy program.
            <br />
            <InitiationFee />
            <br />
            Total payment collected upon acceptance.
          </P>
        </div>
      </Form>
    </>
  );
}
export default function MembershipType({ person }) {
  const nextUrl = "/apply/alliance/";
  const submitUrl = "/api/applications/v4/application/membership_type/";
  const {
    data: {
      prices,
      results: [{ price } = { price: null }],
      results: [{ submission: { membership_price: { membership_price_id } = {} } = {} } = {}] = []
    }
  } = useQuery(["application"]);
  const name = "membership_price_id";
  const defaultPrice = price?.membership_price_id
    ? price.membership_price_id
    : prices
      .filter((n) => n.membership_type_cd === "Member")
      .reduce((_, m) => m.membership_price_id, []);
  const [form, setForm] = useState({
    [name]: membership_price_id === null ? defaultPrice : membership_price_id,
    errors: null
  });
  const initiation_fee_amt = prices
    .filter((n) => n.membership_price_id === form[name])
    .reduce((_, m) => m.initiation_fee_amt, []);
  const isCIR = person !== undefined ? person.membership_type === "Creative in Residence" : false;
  return (
    <Page>
      {isCIR ? (
        <CIR nextUrl={nextUrl} />
      ) : (
        <Standard
          form={form}
          initiation_fee_amt={initiation_fee_amt}
          name={name}
          nextUrl={nextUrl}
          prices={prices}
          setForm={setForm}
          submitUrl={submitUrl}
        />
      )}
    </Page>
  );
}
